<template>
  <iColumn
    width="fill"
    height="hug"
    gap="extraSmall"
    :style-overrides="{
      borderColor: 'striking',
      borderWidth: 'standard',
      borderRadius: 'small',
      paddingTop: 'small',
      paddingBottom: 'small',
      paddingLeft: 'small',
      paddingRight: 'small',
    }"
    :data-test="elementIdentifier ? `broken-element-${elementIdentifier}` : `broken-context-element-${componentName}`"
  >
    <iText variant="error" font-weight="dark">
      {{ heading }}
    </iText>
    <iText
      v-for="(problem, index) in problems"
      :key="index"
      variant="error"
      font-size="small"
    >
      {{ problem }}
    </iText>
  </iColumn>
</template>

<script>
export default {
  name: "BrokenContextElement",
  props: {
    heading: {
      type: String,
      default: "Broken element — context misconfiguration",
    },
    componentName: {
      type: String,
      default: "component",
    },
    problems: {
      type: Array,
      default: () => [],
    },
    // Set by the canvas wrapper so a broken element is addressable by its own
    // id; the in-element usages (feed row, embed host) keep the name-keyed hook.
    elementIdentifier: {
      type: String,
      default: "",
    },
  },
};
</script>
